import { Card } from "@/components/Common";

const AGREEMENT = {
  concorde: "I due sistemi concordano",
  concorde_debole: "Stessa specie, ma Pl@ntNet ha un punteggio basso",
  solo_genere: "Concordano solo sul genere",
  discorde: "I due sistemi danno risultati diversi",
  non_riconosciuta: "Pl@ntNet non ha riconosciuto la specie",
};
const scoreLabel = (s) => (s >= 0.5 ? "alto" : s >= 0.2 ? "medio" : "basso");

export default function SecondOpinion({ ident, busy, onPick, pro }) {
  const pn = ident.plantnet || {};
  const ai = ident.ai || {};
  const top = pn.results?.[0];
  const agreement = ident.confidence?.agreement;
  const discordant = ident.confidence?.discordant;

  if (!pn.available && !pro) {
    return <p className="text-[11px] text-[#8a958d]" data-testid="plantnet-status">Secondo parere Pl@ntNet: {pn.reason || "non disponibile"}</p>;
  }

  return (
    <Card testid="second-opinion-card" className={discordant ? "!border-[#D97706]/60" : ""}>
      <p className="mb-1 text-xs font-semibold uppercase tracking-wider text-[#5b6b60]">Riconoscimento: due pareri separati</p>
      {AGREEMENT[agreement] && (
        <p className={`mb-3 text-sm font-semibold ${discordant ? "text-[#B45309]" : "text-[#0d2517]"}`} data-testid="second-opinion-agreement">{AGREEMENT[agreement]}</p>
      )}
      {discordant && !pro && (
        <p className="mb-3 text-xs text-[#2D3A30]" data-testid="discordance-notice">L'app non sceglie automaticamente: conferma tu la specie, indica quella corretta o aggiungi foto di foglie, fiori o frutti.</p>
      )}
      <div className="grid gap-2">
        <div className="rounded-xl border border-[#ddc69c]/70 p-3" data-testid="opinion-internal">
          <p className="text-[10px] uppercase tracking-wider text-[#8a958d]">Riconoscimento interno (AI)</p>
          <p className="text-sm font-semibold">{ai.common_name || "—"} <span className="botanical font-normal text-[#B39257]">{ai.botanical_name}</span></p>
          <p className="text-[11px] text-[#5b6b60]">Autovalutazione: {ai.self_confidence || "n.d."}</p>
        </div>
        <div className="rounded-xl border border-[#ddc69c]/70 p-3" data-testid="opinion-plantnet">
          <p className="text-[10px] uppercase tracking-wider text-[#8a958d]">Pl@ntNet</p>
          {top ? (
            <>
              <p className="text-sm font-semibold">{top.common_names?.[0] || top.botanical_name} <span className="botanical font-normal text-[#B39257]">{top.botanical_name}</span></p>
              <p className="text-[11px] text-[#5b6b60]">Punteggio {scoreLabel(top.score)}{pro && ` (${top.score})`}</p>
              {pro && pn.results.slice(1, 3).map((r) => <p key={r.botanical_name} className="text-[11px] text-[#5b6b60]">Alternativa: {r.botanical_name} ({r.score})</p>)}
              {!pro && discordant && (
                <button disabled={busy} onClick={onPick} className="btn-secondary mt-2 w-full !py-2 text-xs" data-testid="choose-plantnet-button">È questa la specie corretta</button>
              )}
            </>
          ) : (
            <p className="text-sm text-[#5b6b60]">{pn.reason || "Nessun riscontro"}</p>
          )}
          {pro && pn.sent_photos && <p className="mt-1 text-[10px] text-[#8a958d]">Foto inviate: {pn.sent_photos.length}</p>}
        </div>
      </div>
    </Card>
  );
}
